export class SchemaRegistryAuthConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "SchemaRegistryAuthType",
            "format": ""
        },
        {
            "name": "credentialsSecret",
            "baseName": "credentialsSecret",
            "type": "SchemaRegistryAuthConfigCredentialsSecret",
            "format": ""
        },
        {
            "name": "tlsSecret",
            "baseName": "tlsSecret",
            "type": "KafkaSecurityConfigTlsSecret",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistryAuthConfig.attributeTypeMap;
    }
    constructor() {
    }
}
